import Vue from "vue";
// import "@progress/kendo-ui"; // This will import the entire Kendo UI library
// As an alternative, you could import only the scripts that are used by a specific widget:
import "@progress/kendo-ui/js/kendo.dropdownlist";
import "@progress/kendo-ui/js/kendo.switch";
import "@progress/kendo-ui/js/kendo.colorpicker";

import "@progress/kendo-theme-default/dist/all.css";

import { Grid } from "@progress/kendo-vue-grid";
Vue.component("Grid", Grid);

import { DropdownsInstaller } from "@progress/kendo-dropdowns-vue-wrapper";
import { InputsInstaller } from "@progress/kendo-inputs-vue-wrapper";
// import { LayoutInstaller } from "@progress/kendo-layout-vue-wrapper";

Vue.use(InputsInstaller);
Vue.use(DropdownsInstaller);
// Vue.use(LayoutInstaller);
